/*
 * SPDX-FileCopyrightText: 2023 CERN.
 * SPDX-License-Identifier: MIT
 */

export { InvenioAdministrationActionsApi } from "./actions";
